module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"addDocument":"Dokument hinzufügen","noDocumentsAvailable":"Keine Dokumente vorhanden","documents":"Dokumente"},"en":{"addDocument":"Add document","noDocumentsAvailable":"No documents available","documents":"Documents"}}')
  delete Component.options._Ctor
}
